const getUsernameFromStore = (store) => store.product ?
     store.product.sellerInfo.seller.username :
     store.cart.settings.seller.username;

export default getUsernameFromStore;



// WEBPACK FOOTER //
// ./src/cart/actions/helpers/getUsernameFromStore.js